export default __webpack_public_path__ + "static/media/junior-banner.2b010c32.jpg";